import React from 'react';

import styles from './index.scss';

export * from './subcomponents';

interface Props {
  dashedBorder?: boolean;
  children: any;
}

const Card: React.FC<Props> = ({ children, dashedBorder = false }) => (
  <div className={dashedBorder ? styles.dashedBorderCard : styles.card}>{children}</div>
);

export default Card;
